/*
* @Author: yongwenhao
* @Date: 2020-10-13 10:01:34
* @describe: 媒体及投资者
*/
<template>
    <KllkDrawer v-model="isShowDrawer" class="media-drawer">
        <!-- 按钮 -->
        <div slot="header" class="header-warp">
            <el-button @click="onCancel" class="btns">取消</el-button>
        </div>
        <el-form
                ref="emailForm"
                label-position="left"
                :model="infoFrom"
                label-width="90px"
                class="content"
                disabled
        >
            <el-form-item label="姓名">
                <el-input v-model="infoFrom.partnerName"></el-input>
            </el-form-item>
            <el-form-item label="职位">
                <el-input v-model="infoFrom.position"></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
                <el-input v-model="infoFrom.email"></el-input>
            </el-form-item>
            <el-form-item label="企业名称">
                <el-input v-model="infoFrom.companyName"></el-input>
            </el-form-item>
            <el-form-item label="产品类型">
                <el-input v-model="infoFrom.productType">
                </el-input>
            </el-form-item>
            <el-form-item label="适应症">
                <el-input type="textarea" v-model="infoFrom.indications"></el-input>
            </el-form-item>
            <el-form-item label="时间">
                <el-input v-model="infoFrom.createdTime">
                </el-input>
            </el-form-item>
        </el-form>
    </KllkDrawer>
</template>

<script>
    import KllkDrawer from "../../components/kllk-drawer";

    export default {
        name: "media-drawer",
        props: {
            value: Boolean,
            infoFrom: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        components: {KllkDrawer},
        data() {
            return {
                isShowDrawer: this.value,
            }
        },
        //监听属性 类似于data概念
        computed: {},
        //监控data中的数据变化
        watch: {
            value(n) {
                this.isShowDrawer = n;
            },
            isShowDrawer(n) {
                this.$emit("input", n);
            },
        },
        //方法集合
        methods: {
            onCancel() {
                this.isShowDrawer = false;
            }
        }
    }
</script>

<style lang='less' scoped>
    .media-drawer {
        .header-warp {
            background: #f5f8fa;
            padding: 16px;

            .btns {
                margin: 0 5px;
            }
        }

        .content {
            padding: 20px;
        }
    }
</style>
